module.exports = __webpack_public_path__ + "themes/fq/img/character@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/character@2x.png
// module id = 60
// module chunks = d-game